module.exports = __webpack_public_path__ + "static/img/6.de6647a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/6.png
// module id = ahHn
// module chunks = 0